const STORAGE_KEY = "chatbot-rete-beta-debug-v1";
const MAX_ENTRIES = 500;
const MAX_STORAGE_LENGTH = 200000;

function normalize(value, depth = 0) {
  if (value === null || value === undefined) return value;
  if (depth > 4) return "[limite de profundidade]";
  if (typeof value === "string") return value.slice(0, 1500);
  if (["number", "boolean"].includes(typeof value)) return value;
  if (value instanceof Error)
    return {
      name: value.name,
      message: value.message,
      stack: normalize(value.stack, depth + 1)
    };
  if (Array.isArray(value))
    return value.slice(0, 100).map((item) => normalize(item, depth + 1));
  if (typeof value === "object") {
    return Object.entries(value)
      .slice(0, 50)
      .reduce((result, [key, item]) => {
        result[key] = normalize(item, depth + 1);
        return result;
      }, {});
  }
  return String(value);
}

export function readReteDebugLog() {
  try {
    const parsed = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
}

export function recordReteDebug(event, details = {}) {
  try {
    const entries = readReteDebugLog();
    const entry = {
      timestamp: new Date().toISOString(),
      event,
      details: normalize(details)
    };
    entries.push(entry);
    while (entries.length > MAX_ENTRIES) entries.shift();
    let serialized = JSON.stringify(entries);
    while (serialized.length > MAX_STORAGE_LENGTH && entries.length > 1) {
      entries.shift();
      serialized = JSON.stringify(entries);
    }
    window.localStorage.setItem(STORAGE_KEY, serialized);
  } catch (error) {
    // O editor continua funcionando quando o navegador bloqueia o armazenamento.
  }
}

export function exportReteDebugLog() {
  return JSON.stringify(
    {
      format: "chatbot-rete-beta-debug",
      version: 1,
      exportedAt: new Date().toISOString(),
      userAgent: navigator.userAgent,
      entries: readReteDebugLog()
    },
    null,
    2
  );
}
